import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';


class MySolisitudes extends Component {

    renderCardSolicitud(solicitud) {
        const { t } = this.props;
        return (
            <div className="card-panel-body">
                {solicitud.foto ? (
                    <img
                        className="cover-img__image relative w-full h-full object-cover img-responsive"
                        alt={t('dashboard.profile.img_user')}
                        src={"https://img.iosoffices.com/img/iosfera/usuarios/" + solicitud.foto}
                        loading="lazy" data-embed-id="cover-image" />
                ) : (
                    <img
                        className="cover-img__image relative w-full h-full object-cover img-responsive"
                        alt={t('dashboard.profile.img_user')}
                        src={"https://img.iosoffices.com/img/iosfera/usuarios/default.jpg"}
                        loading="lazy" data-embed-id="cover-image" />
                )}
                <div className="panel-body-title">
                    <div className="container-infomacion">
                        <h4 className="iosname">{solicitud.nombre + " " + solicitud.apellido} {solicitud.usuario_id_solicitante ? "#" + solicitud.usuario_id_solicitante : null}<br></br></h4>
                        <h4 className="iospuesto">{solicitud.puesto ? solicitud.puesto : null} </h4>
                        <h4 className="ioswork ioscentro">{solicitud.empresa ? solicitud.empresa : null} </h4>
                    </div>
                    <div className="container-bootom">
                        <button
                            className="btn btn-block btn-primary btn-singup btn_accept"
                            type="button"
                            onClick={() => this.props.handleacceptConnections(solicitud.usuario_id_solicitante)}>
                            {t('dashboard.conecctions.accept')}
                        </button>
                        <button
                            className="btn btn-block btn-primary btn-singup btn_delate"
                            type="button"
                            onClick={() => this.props.handlegetdelateConnections(solicitud.usuario_id_solicitante)}>
                            {t('dashboard.conecctions.delate')}
                        </button>
                        <Link to={'/user/' + solicitud.usuario_id_solicitante}>
                            <button
                                className="btn btn-block btn-primary btn-singup btn_delate"
                                type="button">

                                {t('guest.benefits.btn_info')}

                            </button>
                        </Link>

                    </div>
                </div>
            </div>
        )

    }

    renderSolicitudes = (Solicitud) => {
        const widthcard = window.screen.width;
        return (
            <div id="carousel-example-generic" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner" role="listbox">
                    {Solicitud.map((solicitud, index) => (
                        index === 0 ? (
                            <div key={index} className="item active">
                                <div className="card-panel panel panel-default card" style={{ display: 'flex' }}>
                                    {this.renderCardSolicitud(solicitud)}
                                    {widthcard >= 1200 ? (
                                        Solicitud[index + 1] ? (
                                            this.renderCardSolicitud(Solicitud[index + 1])
                                        ) : (
                                            <div className="card-panel panel panel-default card " style={{ width: '100%', display: 'none' }}>
                                                <div className="card-panel-body">
                                                    <div className="panel-body-title">
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    ) : null}
                                </div>
                            </div>
                        ) : (
                            <div key={index} className="item">
                                <div className="card-panel panel panel-default card" style={{ display: 'flex' }}>
                                    {this.renderCardSolicitud(solicitud)}
                                    {widthcard >= 1200 ? (
                                        Solicitud[index + 1] ? (
                                            this.renderCardSolicitud(Solicitud[index + 1])
                                        ) : (
                                            this.renderCardSolicitud(Solicitud[0])
                                        )
                                    ) : null}
                                </div>
                            </div>
                        )
                    ))}
                </div>
                <a className="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
                    <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        )
    }

    render() {
        const mySolisitudes = this.props.MySolisitudes;
        return (
            <div className="list-card-conecctions">
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        {mySolisitudes ? (
                            this.renderSolicitudes(mySolisitudes)
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }

}

export default translate('common')(MySolisitudes);


// WEBPACK FOOTER //
// ./src/dashboard/myConecctions/MySolisitudes.js